var render = function render(){var _vm=this,_c=_vm._self._c;return _c('th',{staticClass:"has-text-grey-light is-hidden-mobile"},[_c('input',{staticClass:"is-checkradio",attrs:{"id":_vm.inputId,"type":"checkbox"},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.$emit('change', $event)}}}),_c('label',{attrs:{"for":_vm.inputId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }